var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicOrd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.58579 0.620248C1.78814e-07 1.24049 0 2.23876 0 4.23529V13.7647C0 15.7612 1.78814e-07 16.7595 0.58579 17.3797C1.17157 18 2.11438 18 4 18H10C11.8856 18 12.8284 18 13.4142 17.3797C14 16.7595 14 15.7612 14 13.7647V4.23529C14 2.23876 14 1.24049 13.4142 0.620248C12.8284 1.89332e-07 11.8856 0 10 0H4C2.11438 0 1.17157 1.89332e-07 0.58579 0.620248ZM4 4.23529C3.44772 4.23529 3 4.70935 3 5.29412C3 5.87888 3.44772 6.35294 4 6.35294H10C10.5523 6.35294 11 5.87888 11 5.29412C11 4.70935 10.5523 4.23529 10 4.23529H4ZM4 8.47059C3.44772 8.47059 3 8.94462 3 9.52941C3 10.1142 3.44772 10.5882 4 10.5882H10C10.5523 10.5882 11 10.1142 11 9.52941C11 8.94462 10.5523 8.47059 10 8.47059H4ZM4 12.7059C3.44772 12.7059 3 13.1799 3 13.7647C3 14.3495 3.44772 14.8235 4 14.8235H8C8.5523 14.8235 9 14.3495 9 13.7647C9 13.1799 8.5523 12.7059 8 12.7059H4Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicOrd);
export default __webpack_public_path__ + "static/media/tic_ord.0460dd1ff9bfb8ef205eb7dcf230d025.svg";
export { ForwardRef as ReactComponent };